import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { _ } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { FormatComponent } from '../base-components/format-component';

@Injectable()
export class MatPaginatorTranslations extends FormatComponent implements MatPaginatorIntl {
  changes = new Subject<void>();

  constructor() {
    super();
    this.translateLabels();

    this.subscribe(this.translate.onLangChange, () => {
      this.translateLabels();
      this.changes.next();
    });
  }

  itemsPerPageLabel = '';
  firstPageLabel = '';
  lastPageLabel = '';
  nextPageLabel = '';
  previousPageLabel = '';
  pageLabel = '';
  pageOfLabel = '';

  private translateLabels() {
    this.itemsPerPageLabel = this.translate.instant(_('paginator_itemssperpage_label'));
    this.firstPageLabel = this.translate.instant(_('paginator_firstpage_label'));
    this.lastPageLabel = this.translate.instant(_('paginator_lastpage_label'));
    this.nextPageLabel = this.translate.instant(_('paginator_nextpage_label'));
    this.previousPageLabel = this.translate.instant(_('paginator_previouspage_label'));
    this.pageLabel = this.translate.instant(_('paginator_page_label'));
    this.pageOfLabel = this.translate.instant(_('paginator_pageof_label'));
  }

  getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0) {
      // return `${this.pageLabel} 0 ${this.pageOfLabel} 0`;
      return `0 ${this.pageOfLabel} 0`;
    }
    // const amountPages = Math.ceil(length / pageSize);
    const startRange = page * pageSize + 1;
    const endRange = startRange + pageSize - 1;
    return `${startRange}-${endRange < length ? endRange : length} ${this.pageOfLabel} ${length}`;
    // return `${this.pageLabel} ${startRange}-${endRange < length ? endRange : length} ${this.pageOfLabel} ${length}`;
  }
}
